import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importWithdrawalSwitcherContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "WithdrawalSwitcherContainer" */
                '@perpay-web/fintech/components/containers/WithdrawalSwitcherContainer'
            ),
    );
